import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import arrayMutators from 'final-form-arrays';
import { useIntl } from 'react-intl';

import PageBaseProps from   'types/PageBase';
import AdviceStatus from 'types/AdviceStatus';
import FormKeys from 'modules/form/types/FormKeys';
import type { FormValidatorWithIntl } from 'types/Form';
import type { ExtrasForm as ExtrasFormType } from 'types/ExtrasForm';

import { useSelector } from 'hooks';

import { isModalOpen } from 'modules/basket/selectors';

import ConnectedForm from 'components/ui/ConnectedForm';

import ExtrasFormRender from './ExtrasFormRender';
import PopupErrorForm from '../Errors/PopupErrorForm';
import { setIn } from 'final-form';

export const validateForm: FormValidatorWithIntl<ExtrasFormType> = (intl) => (
  { extras = [] },
) => extras.reduce((acc, extra, index) => {
  if (extra.mandatory && extra.status === AdviceStatus.PENDING) {
    return setIn(acc, `extras[${index}].status`, intl.formatMessage({
      id: 'validation.required',
      defaultMessage: 'Please answer to continue.',
    }));
  }
  return acc;

}
, {});

const ExtrasForm: React.FC<PageBaseProps> = ({ onNext, ...pageProps }) => {
  const intl = useIntl();
  const isBasketModalOpen = useSelector(isModalOpen);
  const [key, setKey] = React.useState(uuidv4());

  // Use to refresh the form when it has been updated in the basket modal.
  React.useEffect(() => {
    if (!isBasketModalOpen) {
      setKey(uuidv4());
    }
  }, [isBasketModalOpen]);

  return (
    <React.Fragment key={key}>
      <ConnectedForm
        onSubmit={onNext}
        formKey={FormKeys.EXTRAS}
        component={ExtrasFormRender}
        validate={validateForm(intl)}
        mutators={{ ...arrayMutators }}
        subscription={{ hasValidationErrors: true }}
        {...pageProps}
        errorComponent={<PopupErrorForm errorMessage={{
          id: 'extras.mandatoryModal.title',
          defaultMessage: 'You must first answer {count, plural, one {the extra} other {all extras}} marked with "{mandatory}".',
        }} />}
      />
    </React.Fragment>
  );
};

export default ExtrasForm;
